module.exports = "<li>\n\t<a href=\"<%= link %>\" target=\"_blank\" class=\"home_instagram-link\" style=\"background-image: url(<%= images.standard_resolution.url %>);\">\n\t\t<img src=\"<%= images.standard_resolution.url %>\" alt=\"\" style=\"opacity:0;\">\n\t</a>\n</li>\n";


//////////////////
// WEBPACK FOOTER
// ./dev/js/scripts/_template.html
// module id = 28
// module chunks = 0